import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { useSelector } from 'react-redux';
import { StringHelpers, SystemText } from 'e4shared';
import { isBefore, isAfter, addMinutes, addDays } from 'helpers/dates';
import CustomToolTip from 'views/myDashboard/components/widgets/_tooltip';

const Chart = ({ data, keys, metric, format, task }) => {
    const user = useSelector(state => state.user.user);

    const st = (path, ...rest) => SystemText(`Objective/MetricGraph/${path}`, ...rest);

    const getColour = ({ id, data }) => {
        const start = addMinutes(task.date_Assigned, -1);
        const end = addMinutes(task.due, 1);
        const i = isBefore(data.date, start) || isAfter(data.date, end) ? '0.5' : '1';
        return id !== st('Actual') ? `rgba(204, 98, 80, ${i})` : `rgba(126, 190, 178, ${i})`;
    };

    return (
        <ResponsiveBar
            data={data}
            keys={keys}
            margin={{ top: 20, right: 130, bottom: 60, left: 80 }}
            padding={0.2}
            innerPadding={2}
            groupMode="grouped"
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            valueFormat={x => 'foo'}
            colors={d => getColour(d)}
            borderRadius={2}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', '0.5']] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: st('Date'),
                legendPosition: 'middle',
                legendOffset: 40,
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: '', //metric || 'Value',
                legendPosition: 'middle',
                legendOffset: -65,
                format: x => StringHelpers.formatMetric(format, x, user.currencySymbol),
            }}
            enableLabel={false}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
            tooltip={point => (
                <CustomToolTip
                    point={point}
                    legend={point.indexValue}
                    x="id"
                    y="value"
                    xFormat={x => point.id}
                    yFormat={x => StringHelpers.formatMetric(metric.format, point.value, user.currencySymbol)}
                />
            )}
        />
    );
};

export default Chart;
